import React from 'react';
import PropTypes from 'prop-types';

import { StyledPagesSelectLabel, StyledPagesSelect } from './styles';
import { useSearchState } from '../../../context';

const createOptions = (total) => {
  return Array.from({ length: total }, (_, i) => ({
    value: i + 1,
    display: `${i + 1} of ${total}`
  }));
};

// Creates Options based on total amount
const PagesSelect = () => {
  const { page, pagesTotal, onPageChange } = useSearchState();

  if (!pagesTotal) return null;
  const options = createOptions(pagesTotal);
  
  const handlePageChange = (e) => {
    if (e.value === page) return;
    // Scroll page to the top when change page
    window.scroll({ top: 0 });
    onPageChange(e.value);
  };
 
  return (
    <StyledPagesSelect
      id="pagination"
      initialValue={page}
      options={options}
      MenuLabel={props => <StyledPagesSelectLabel {...props} page={page} />}
      onChange={handlePageChange}
    />
  );
};

PagesSelect.propTypes = {
  pagesTotal: PropTypes.number,
  page: PropTypes.number,
  onChange: PropTypes.func
};

export default PagesSelect;
